import {
  FILE_AUTH_JWT,
  IMPERSONATED_USER_ID,
  ORGANIZATION_ID,
  CAMPAIGN_PREVIEW
} from '@src/constants/local-storage-ids';

// localStorage
export const getImpersonatedUserId = () => {
  return localStorage.getItem(IMPERSONATED_USER_ID);
};

export const getOrganizationIdentification = () => {
  return localStorage.getItem(ORGANIZATION_ID);
};

export const setCampaignPreview = (value) => {
  localStorage.setItem(CAMPAIGN_PREVIEW, value);
};
export const getCampaignPreview = () => {
  return localStorage.getItem(CAMPAIGN_PREVIEW);
};
export const removeCampaignPreview = () => {
  localStorage.removeItem(CAMPAIGN_PREVIEW);
};

// sessionStorage
export const setFileAuthJwt = (value) => {
  sessionStorage.setItem(FILE_AUTH_JWT, value);
};
export const getFileAuthJwt = () => {
  return sessionStorage.getItem(FILE_AUTH_JWT);
};
export const removeFileAuthJwt = () => {
  sessionStorage.removeItem(FILE_AUTH_JWT);
};



// WEBPACK FOOTER //
// ./src/utils/windowStorage.js